<template>
  <div class="grid" @click.stop="">
    <div class="col-12">
      <!--SUSPENDER RECLAMACION --->
      <Dialog
        :header="
          $t('reclamacion.detalleReclamacion.dialogSuspenderReclamacion')
        "
        :modal="true"
        :visible.sync="displaydialogSuspenderReclamacion"
        :contentStyle="{ overflow: 'visible' }"
      >
        <p>
          {{
            $t("impago.mensajeDialogSuspenderImpago", {
              token: this.reclamacion.token,
            })
          }}
        </p>
        <Errors
          v-show="this.errorsFieldsSuspension.length > 0"
          :errors="this.errorsFieldsSuspension"
        />
        <div class="grid p-fluid p-formgrid">
          <div class="p-field col-12 md:col-6 md:col-offset-3">
            <Dropdown
              v-model="selectedMotivoSuspension"
              :options="this.dropdownMotivoSuspension"
              optionLabel="name"
              :placeholder="
                $t('reclamacion.detalleReclamacion.dialogSelectSuspension')
              "
              :filter="false"
              @change="changeSelectedSuspension"
            />
          </div>
          <div class="field col-12 md:col-8 md:col-offset-2 calendarImpago">
            <label for="basic">{{
              $t("reclamacion.detalleReclamacion.fechaLimiteSuspension")
            }}</label>
            <Calendar
              id="icon"
              v-model="suspensionDate"
              :minDate="minSuspensionDate"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :showTime="true"
              :locale="getLocale"
            />
          </div>
        </div>
        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="suspendReclamacion()"
            :disabled="submitingAction"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closeSuspendReclamacion"
            :disabled="submitingAction"
          />
        </template>
      </Dialog>

      <!--CANCELAR RECLAMACION -->
      <Dialog
        :header="$t('reclamacion.detalleReclamacion.dialogCancelarReclamacion')"
        :modal="true"
        :visible.sync="displaydialogCancelarReclamacion"
        :contentStyle="{ overflow: 'visible' }"
      >
        <p>
          {{
            $t("impago.mensajeDialogCancelarImpago", {
              token: this.reclamacion.token,
            })
          }}
        </p>
        <Errors
          v-show="this.errorsFieldsCancel.length > 0"
          :errors="this.errorsFieldsCancel"
        />
        <Dropdown
          v-model="selectedMotivoCancelacion"
          :options="this.dropdownMotivoCancelacion"
          optionLabel="name"
          :placeholder="$t('reclamacion.detalleReclamacion.dialogSelectCancel')"
          :filter="false"
          @change="changeSelectedCancelacion"
        />

        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="cancelReclamacion()"
            :disabled="submitingAction"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closeCancelReclamacion"
            :disabled="submitingAction"
          />
        </template>
      </Dialog>

      <!--PAGO PARCIAL --->

      <Dialog
        :header="
          $t('reclamacion.detalleReclamacion.dialogPagoParcialReclamacion')
        "
        :modal="true"
        :visible.sync="displaydialogPagoParcialReclamacion"
        :contentStyle="{ overflow: 'visible' }"
      >
        <Errors
          v-show="this.errorsFieldsPagoParcial.length > 0"
          :errors="this.errorsFieldsPagoParcial"
        />

        <div class="grid p-fluid p-formgrid">
          <div class="col-12 md:col-4 p-field">
            <label for="fechaPago"
              ><b>{{
                $t("reclamacion.detalleReclamacion.fechaPago")
              }}</b></label
            >
            <div class="p-inputgroup">
              <Calendar
                id="fechaPago"
                v-model="fechaPago"
                dateFormat="dd/mm/yy"
                :showIcon="true"
                :showTime="false"
                :locale="getLocale"
              />
            </div>
          </div>
          <div class="col-12 md:col-4 md:col-offset-1 p-field">
            <label for="qty"
              ><b>{{
                $t(
                  "reclamacion.detalleReclamacion.mensajeDialogPagoParcialReclamacion"
                )
              }}</b></label
            >
            <div class="p-inputgroup">
              <InputText
                type="number"
                id="qty"
                v-model="qty"
              />
              <!-- :disabled="pagoTotal" -->
            </div>
          </div>
          <div class="col-12 md:col-3 p-field">
            <label for="motivo-actualizacion"
              ><b>{{
                $t(
                  "reclamacion.detalleReclamacion.mensajeDialogPagoParcialMotivoActualizacion"
                )
              }}</b></label
            >
            <Dropdown
              v-model="motivoActualizacion"
              class="input"
              :options="listadoMotivosActualizacion"
              optionLabel="valor"
              optionValue="clave"
              @change="onMotivoActualizacionChange"
              id="motivo-actualizacion"
              :placeholder="
                $t(
                  'reclamacion.detalleReclamacion.placeholderDialogPagoParcialMotivoActualizacion'
                )
              "
            />
          </div>
          <div class="col-12 md:col-4 p-field">
            <label for="documentoPagoParcial"
              ><b>{{
                $t("reclamacion.detalleReclamacion.documento")
              }}</b></label
            >
            <div class="p-inputgroup">
              <input
                type="file"
                id="documentoPagoParcial"
                ref="documentoPagoParcial"
                @change="handleFileUploadPagoParcial()"
              />
            </div>
          </div>
        </div>

        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="comprobarPagoParcialImpago()"
            :disabled="submitingAction"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closePagoParcial"
            :disabled="submitingAction"
          />
        </template>
      </Dialog>

      <Button
        v-tooltip.bottom="$t('operacion.botonAgregarPagoParcial')"
        v-if="canPay(reclamacion.estado)"
        type="button"
        icon="pi pi-dollar"
        class="p-button-success"
        style="margin-right: 0.5em"
        @click="openDialog('PAGO_PARCIAL_IMPAGO')"
      />
      <Button
        v-tooltip.bottom="$t('operacion.botonSuspenderReclamacion')"
        v-if="
          canExecuteTransition(
            reclamacion.listadoTransiciones,
            reclamacion.estado,
            statuses.SUSPENDIDA
          )
        "
        type="button"
        icon="pi pi-calendar-times"
        class="p-button-success"
        style="margin-right: 0.5em"
        @click="openDialog('SUSPENDIDA')"
      />
      <Button
        v-tooltip.bottom="$t('operacion.botonCancelarReclamacion')"
        v-if="
          canExecuteTransition(
            reclamacion.listadoTransiciones,
            reclamacion.estado,
            statuses.CANCELADA
          )
        "
        type="button"
        icon="pi pi-times"
        class="p-button-success"
        style="margin-right: 0.5em"
        @click="openDialog('CANCELADA')"
      />
    </div>
  </div>
</template>
<script>
import Errors from "@/components/utilidades/Errors.vue";
import {
  BOTONERA_ACCIONES_PAGO_PARCIAL_IMPAGO,
  MUTATION_CANCEL_CLAIM,
  MUTATION_SUSPEND_CLAIM,
} from "@/graphQLQueries/ReclamacionQueries";
import { BOTONERA_ACCIONES_LISTADOS_CON_NOTARIOS } from "@/graphQLQueries/OtrosQueries";
import { ESTADOS } from "@/resources/constants";
import ActionsMixin from "@/utils/actions";

export default {
  components: {
    Errors: Errors,
  },
  props: ["impagoUuid", "reclamacion", "importePendiente"],
  mixins: [ActionsMixin],
  data() {
    return {
      posiblesAcciones: [],
      listadoEstadosPermitidosHash: {},
      displaydialogCancelarReclamacion: false,
      displaydialogSuspenderReclamacion: false,
      displaydialogFaseAmistosaReclamacion: false,
      displaydialogRecuperarReclamacion: false,
      displaydialogValidarReclamacion: false,
      displaydialogEnNotariaReclamacion: false,
      displaydialogActaProvisionalReclamacion: false,
      displaydialogActaDefinitivaReclamacion: false,
      displaydialogPagoParcialReclamacion: false,
      displaydialogReactivarReclamacion: false,
      displaydialogIncluirReclamacion: false,
      actaProvisionalReclamacionFechaEnvio: null,
      actaProvisionalReclamacionLocalizador: null,
      fileActaProvisional: "",

      actaDefinitivaReclamacionFechaEnvio: null,
      actaDefinitivaReclamacionLocalizador: null,
      actaDefinitivaReclamacionAlegaciones: false,
      fileActaDefinitiva: "",

      dropdownMotivoCancelacion: [],
      dropdownMotivoSuspension: [],
      selectedMotivoCancelacion: {},
      selectedMotivoSuspension: {},
      suspensionDate: null,
      previousMonthToday: null,
      minSuspensionDate: null,
      errorsFieldsInclusion: [],
      errorsFieldsCancel: [],
      errorsFieldsSuspension: [],
      errorsFieldsFriendlyPhase: [],
      errorsFieldsValidate: [],
      errorsFieldsRecover: [],
      errorsFieldsNotary: [],
      errorsFieldsProvisional: [],
      errorsFieldsDefinitive: [],
      errorsFieldsPagoParcial: [],
      errorsFieldsDescargaPdf: [],
      errorsFieldsReactivation: [],
      dropdownNotarios: [],
      selectedNotary: {},
      qty: 0,
      fechaPago: null,
      comisiona: false,
      observacionesPagoParcial: "",
      filePagoParcial: "",
      filenamePagoParcial: "",
      fileBase64PagoParcial: null,
      listaEstados: [],
      listaAcciones: [],
      submitingAction: false,
      statuses: ESTADOS,
      motivoActualizacion: null,
      motivosActualizacion: {
        pago: {
          valor: this.$t(
            "reclamacion.detalleReclamacion.itemDialogPagoParcialMotivoActualizacionPago"
          ),
          clave: "PAGO",
        },
        condonacion: {
          valor: this.$t(
            "reclamacion.detalleReclamacion.itemDialogPagoParcialMotivoActualizacionCondonacion"
          ),
          clave: "CONDONACION",
        },
        error: {
          valor: this.$t(
            "reclamacion.detalleReclamacion.itemDialogPagoParcialMotivoActualizacionError"
          ),
          clave: "ERROR",
        },
      },
    };
  },
  computed: {
    getLocale() {
      return this.$i18n.t("calendar");
    },
    listadoMotivosActualizacion() {
      return [
        {
          valor: this.motivosActualizacion.pago.valor,
          clave: this.motivosActualizacion.pago.clave,
        },
        {
          valor: this.motivosActualizacion.condonacion.valor,
          clave: this.motivosActualizacion.condonacion.clave,
        },
        {
          valor: this.motivosActualizacion.error.valor,
          clave: this.motivosActualizacion.error.clave,
        },
      ];
    },
  },
  methods: {
    openDialog(type) {
      this.submitingAction = false;
      switch (type) {
        case "CANCELADA":
          this.selectedMotivoCancelacion = {};
          this.displaydialogCancelarReclamacion = true;
          break;
        case "SUSPENDIDA":
          this.selectedMotivoSuspension = {};
          this.suspensionDate = null;
          this.displaydialogSuspenderReclamacion = true;
          break;
        case "PAGO_PARCIAL_IMPAGO":
          this.comisiona = false;
          this.errorsFieldsPagoParcial = [];
          this.fechaPago = null;
          this.qty = 0;
          this.filePagoParcial = null;
          this.filenamePagoParcial = "";
          this.fileBase64PagoParcial = null;
          this.observacionesPagoParcial = "";
          this.displaydialogPagoParcialReclamacion = true;
          this.motivoActualizacion = null;
          break;
        default:
          break;
      }
    },
    onMotivoActualizacionChange(evt) {
      switch (evt.value) {
        case this.motivosActualizacion.pago.clave:
          this.comisiona = true;
          this.observacionesPagoParcial = this.$t(
            "reclamacion.detalleReclamacion.itemDialogPagoParcialMotivoActualizacionPago"
          );
          break;
        case this.motivosActualizacion.condonacion.clave:
          this.comisiona = false;
          this.observacionesPagoParcial = this.$t(
            "reclamacion.detalleReclamacion.itemDialogPagoParcialMotivoActualizacionCondonacion"
          );
          break;
        case this.motivosActualizacion.error.clave:
          this.comisiona = false;
          this.observacionesPagoParcial = this.$t(
            "reclamacion.detalleReclamacion.itemDialogPagoParcialMotivoActualizacionError"
          );
          break;
        default:
          this.comisiona = false;
          this.observacionesPagoParcial = "";
      }
    },
    closePagoParcial() {
      this.displaydialogPagoParcialReclamacion = false;
      this.errorsFieldsPagoParcial = [];
    },
    closeCancelReclamacion() {
      this.displaydialogCancelarReclamacion = false;
      this.errorsFieldsCancel = [];
    },
    closeSuspendReclamacion() {
      this.displaydialogSuspenderReclamacion = false;
      this.errorsFieldsSuspension = [];
    },
    comprobarPagoParcialImpago() {
      this.errorsFieldsPagoParcial = [];
      let enviar = true;
      if (!this.qty) {
        this.errorsFieldsPagoParcial.push(
          this.$t("acciones.errores.importeObligatorio")
        );
        enviar = false;
      } else if (this.qty > this.importePendiente) {
        this.errorsFieldsPagoParcial.push("acciones.errores.importePendiente");
        enviar = false;
      }
      if (!this.fechaPago) {
        this.errorsFieldsPagoParcial.push(
          this.$t("acciones.errores.fechaObligatorio")
        );
        enviar = false;
      }
      if (!this.motivoActualizacion) {
        this.errorsFieldsPagoParcial.push(
          this.$t("acciones.errores.motivoActualizacionObligatorio")
        );
        enviar = false;
      }
      if (enviar) {
        this.pagoParcialImpago();
      }
    },
    pagoParcialImpago() {
      this.submitingAction = true;
      this.$apollo
        .mutate({
          mutation: BOTONERA_ACCIONES_PAGO_PARCIAL_IMPAGO,
          variables: {
            impagoUuid: this.impagoUuid,
            importe:
              this.qty != null && this.qty != "" && !isNaN(this.qty)
                ? this.qty
                : 0,
            divisa: this.divisa,
            noComisiona: !this.comisiona,
            filename: this.filenamePagoParcial,
            fileBase64: this.fileBase64PagoParcial,
            usuarioUuid: this.$store.state.profile.uuid,
            observaciones: this.observacionesPagoParcial,
            fechaPago: this.fechaPago != null ? this.fechaPago.getTime() : null,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.displaydialogPagoParcialReclamacion = false;
          this.processAction();
        })
        .catch((exception) => {
          this.submitingAction = false;
          this.errorsFieldsPagoParcial = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsPagoParcial.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    processAction() {
      this.$emit("on-action-processed", true);
    },
    handleFileUploadPagoParcial() {
      this.filePagoParcial = this.$refs.documentoPagoParcial.files[0];
      if (this.filePagoParcial != null && this.filePagoParcial != undefined) {
        var reader = new FileReader();
        reader.readAsDataURL(this.filePagoParcial);
        let self = this;
        reader.onload = function () {
          self.filenamePagoParcial = self.filePagoParcial.name;
          self.fileBase64PagoParcial = reader.result;
        };
        reader.onerror = function (error) {
          console.error(error);
          self.filenamePagoParcial = "";
          self.fileBase64PagoParcial = null;
        };
      }
    },
    cancelReclamacion() {
      this.submitingAction = true;
      this.$apollo
        .mutate({
          mutation: MUTATION_CANCEL_CLAIM,
          variables: {
            motivoCancelacion: this.selectedMotivoCancelacion.code || "",
            tokenReclamacion: this.reclamacion.token,
            usuarioUuid: this.$store.state.profile.uuid,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          // Result
          this.submitingAction = false;
          this.errorsFieldsCancel = [];
          this.displaydialogCancelarReclamacion = false;
          this.processAction();
        })
        .catch((exception) => {
          this.submitingAction = false;
          this.errorsFieldsCancel = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsCancel.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    changeSelectedCancelacion(event) {
      this.selectedMotivoCancelacion = event.value;
    },
    changeSelectedSuspension(event) {
      this.selectedMotivoSuspension = event.value;
    },
    suspendReclamacion() {
      this.submitingAction = true;
      this.$apollo
        .mutate({
          mutation: MUTATION_SUSPEND_CLAIM,
          variables: {
            fechaLimite:
              this.suspensionDate != null
                ? this.suspensionDate.getTime()
                : this.previousMonthToday.getTime(),
            motivoSuspension: this.selectedMotivoSuspension.code || "",
            tokenReclamacion: this.reclamacion.token,
            usuarioUuid: this.$store.state.profile.uuid,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.submitingAction = false;
          this.errorsFieldsSuspension = [];
          this.displaydialogSuspenderReclamacion = false;
          this.processAction();
        })
        .catch((exception) => {
          this.submitingAction = false;
          this.errorsFieldsSuspension = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsSuspension.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    canPay(estadoReclamacion) {
      const estadosNoPermitidos = [
        this.statuses.SUSPENDIDA,
        this.statuses.CANCELADA,
        this.statuses.RECUPERADA,
      ];

      return !estadosNoPermitidos.includes(estadoReclamacion);
    },
    // changePagoTotal() {
    //   if (this.pagoTotal) {
    //     this.qty = this.importePendiente;
    //   }
    // },
  },
  apollo: {
    listadosDropdowns: {
      query: BOTONERA_ACCIONES_LISTADOS_CON_NOTARIOS,
      variables() {
        return {
          idioma: this.$i18n.locale,
        };
      },
      update(data) {
        const dropdownCancelacion =
          data.listadoMotivosCancelacionReclamacion.map((motivo) => {
            return {
              name: motivo.valor,
              code: motivo.clave,
            };
          });
        const dropdownSuspension = data.listadoMotivosSuspension.map(
          (motivo) => {
            return {
              name: motivo.valor,
              code: motivo.clave,
            };
          }
        );
        this.dropdownMotivoCancelacion = dropdownCancelacion;
        this.dropdownMotivoSuspension = dropdownSuspension;
        if (this.esReclamacionNotarial) {
          const dropdownNotario = data.listaNotarios.map((notario) => {
            return {
              name: this.getFullName(notario.nombre, notario.apellidos, null),
              code: notario.uuid,
            };
          });
          this.dropdownNotarios = dropdownNotario;
        }
      },
    },
  },
};
</script>

<style>
  .calendarImpago div.p-datepicker{
    left: -200px !important;
    right: 200px;
  }
</style>